const triggerCustomerSignOn = (country, lang, sessionId, clientIp, userData, host) => {
    const blackBoxString =  window.sessionStorage.getItem('blackBoxString');
    const reqPayload = {
        gateway_customer: {
            identities: {
                identity: [{
                        data: userData.emailId,
                        type: "USERNAME"
                    },
                    {
                        data: userData.password,
                        type: "PASSWORD"
                    }
                ]
            }
        },
        analytics: {
            state: null,
            analytic_event: {
                fields: {
                    field: [{
                            name: "forgotPasswordFlag",
                            value: "N"
                        },
                        {
                            name: "loginErrorCount",
                            value: "0"
                        },
                        {
                            name: "siteInfoLoginUser",
                            value: userData.emailId
                        },
                        {
                            name: "queryString",
                            value: ""
                        },
                        {
                            name: "wuRevision",
                            value: "Optimus"
                        },
                        {
                            name: "codebase",
                            value: ""
                        },
                        {
                            name: "lightboxFlag",
                            value: "N"
                        },
                        {
                            name: "siteCatalystVersion",
                            value: ""
                        },
                        {
                            name: "forgotUsernameFlag",
                            value: "N"
                        }
                    ]
                }
            }
        },
        device: {
            id: "",
            type: "WEB"
        },
        external_reference_no: "1",
        channel: {
            name: "Western Union",
            type: "WEB",
            version: "9Z00",
            device_identifier: "RESPONSIVE_WEB",
            source: "WU_DIGITAL_SCV"
        },
        security: {
            session: {
                id: sessionId
            },
            client_ip: clientIp,
            version: "2",
            black_box_data: {
               ...(blackBoxString && {
                  data: blackBoxString
                }),
                length: blackBoxString?.length ? `${blackBoxString?.length.toString()}` : '0'
            }
        },
        bashPath: `/${country}/${lang}`
    };

    const countryCode = (getCookieValueByKeyName('WUCountryCookie_') || '').toUpperCase();
    if(WU_DIGITAL_SCV_COUNTRIES.indexOf(countryCode) < 0) {
        delete reqPayload.channel.source
    }

    const requestOptions = {
        method: "POST",
        headers: {
            "accept": "application/json, text/plain, */*",
            "Content-Type": "application/json",
            "accept-language": "en-US,en;q=0.9"
        },
        body: JSON.stringify(reqPayload)
    };
    return fetchApiWu(`https://${host}/wuconnect/rest/api/v2.0/CustomerSignOn?timestamp=${new Date().getTime()}`, requestOptions, "CustomerSignOn")
};